import { type ServiceManager } from '@/framework/services/service-manager';
import { type IShape } from '@/utils/collision-kit';

/** 操作节点在普通模式阻断图层 hover；格式刷模式仍需继续按坐标解析实际目标。 */
export function shouldSkipHoverTarget(operateType: unknown, targetType: unknown, isFormatBrushActive: boolean) {
    return !isFormatBrushActive && !!(operateType || targetType);
}

/**
 * 将鼠标命中的外层图层解析为格式刷实际作用的图层。
 *
 * 组图层只返回坐标下最上层子图层；组内间隙不会回退为组外壳。
 */
export function resolveFormatBrushTargetId(service: ServiceManager, mouseRect: IShape, outerLayerId: string) {
    if (!outerLayerId) return '';
    const outerLayer = service.flatLayer.getLayer(outerLayerId);
    if (!outerLayer) return '';
    if (!outerLayer.children?.length) return outerLayerId;
    return service.transform.tryPickChild(mouseRect, outerLayer.children);
}
